// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__nlASx","content":"App_content__naSmy","open":"App_open__EKRgz"};